import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '../styles/override.styl';

declare module 'vue/types/vue' {
  interface Vue {
    $vuetify: Vuetify;
  }
}

Vue.use(Vuetify, {
  theme: {
    // green
    primary: { base: '#24ddaf' },
    // grey
    secondary: { base: '#e7dfe4', lighten1: '#f5f5f5' },
    // blue
    tertiary: { base: '#092c4f' },
  },
  options: {
    customProperties: true,
  },
});
